<template>
  <v-container fluid>
    <v-card class="pl-6 pr-6 pt-6 pb-6">
      <v-row>
        <v-col cols="6" md="6">
          <v-card-title class="text-h5">Add Invoice Title</v-card-title>
        </v-col>
      </v-row>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <h3><span class="red--text">* </span>Title</h3>
            <v-text-field v-model="title_inv" outlined dense></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <h3>Unit</h3>
            <v-combobox v-model="unit" :items="unitOptions" placeholder="เลือกจากรายการ หรือพิมพ์เอง" outlined
              dense></v-combobox>
          </v-col>
          <v-col cols="12" md="3">
            <h3>Price</h3>
            <v-text-field v-model="price" outlined dense type="Number"></v-text-field>
          </v-col>


        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row align="center">
          <v-spacer></v-spacer>
          <v-btn depressed width="100" class="mr-3 buttonblue" @click="saveaddItem()">
            Save
          </v-btn>
          <v-btn depressed outlined width="100" @click="$router.back()">
            Cance
          </v-btn>
          <v-spacer></v-spacer>
        </v-row>
      </v-card-actions>
    </v-card>
    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

    <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
  </v-container>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "./computing/tolocalestringnumber";

export default {
  name: "NewAdvance",
  data() {
    return {
      document_type: "",
      price: 0,
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      title_inv: "",
      unit: "",
      unitOptions: ["ครั้ง", "ชม.", "วัน", "เดือน", "ปี", "งาน", "คดี"],
    };
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
  },
  computed: {},
  watch: {},
  async mounted() {
    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }

    if (this.$route.params.mode == "Edit") {
      await this.loaddata();
    }
    this.$hideLoader();
  },
  methods: {
    async loaddata() {
      const res_result = await api.billing_expense_getInvTitleByID(
        this.$route.params.id
      );
      // console.log(res_result.data)
      this.title_inv = res_result.data[0].title;
      this.price = res_result.data[0].price;
      this.unit = res_result.data[0].unit;
    },
    async saveaddItem() {
      if (this.title_inv == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check information",
          "Please Enter Title Data",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.$route.params.mode == "Add") {
        const additem = {
          title: this.title_inv,
          price: Number(this.price),
          unit: this.unit,
          dept_id: localStorage.getItem(server.DEPARTMENT_ID),
          company_id: localStorage.getItem(server.COMPANYID),
          user_create: localStorage.getItem(server.USER_ID),
        };
        // console.log(additem)
        this.$showLoader();
        const res_add = await api.billing_expense_addInvTitle(additem);
        if (res_add.status == 200) {
          this.$hideLoader();
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "Information Saved",
            "Information successfully saved",
            "text-h5 green--text text-center",
            `/invoice-title`
          );
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
        }
      } else {
        const editItem = {
          title: this.title_inv,
          price: Number(this.price),
          unit: this.unit,
          user_update: localStorage.getItem(server.USER_ID),
        };
        this.$showLoader();
        const res_edit = await api.billing_expense_UpdateInvTitle(
          this.$route.params.id,
          editItem
        );
        if (res_edit.status == 200) {
          this.$hideLoader();
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "Information Saved",
            "Information successfully saved",
            "text-h5 green--text text-center",
            `/invoice-title`
          );
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
        }
      }
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
  },
  async beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.center {
  text-align: center;
}
</style>